import { render, staticRenderFns } from "./Stopwatch.vue?vue&type=template&id=0228ca1b&scoped=true&"
import script from "./Stopwatch.vue?vue&type=script&lang=js&"
export * from "./Stopwatch.vue?vue&type=script&lang=js&"
import style0 from "./Stopwatch.vue?vue&type=style&index=0&id=0228ca1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228ca1b",
  null
  
)

export default component.exports